import api from './../libs/api';

export default {
  // Get all promo codes (admin only)
  getAll: (page = 1) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`promo-codes?page=${page}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Get promo codes failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  // Get promo code by ID (admin only)
  getById: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`promo-codes/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Get promo code failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  // Create new promo code (admin only)
  create: (data) => {
    return new Promise((resolve, reject) => {
      api()
        .post('promo-codes', data)
        .then(({ status, data }) => {
          if (status === 201) resolve(data);
          throw new Error(`Create promo code failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  // Update promo code (admin only)
  update: (id, data) => {
    return new Promise((resolve, reject) => {
      api()
        .put(`promo-codes/${id}`, data)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Update promo code failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  // Delete promo code (admin only)
  delete: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`promo-codes/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Delete promo code failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  // Validate promo code (user)
  validate: (code) => {
    return new Promise((resolve, reject) => {
      api()
        .post('promo-codes/validate', { code })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Validate promo code failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  // Generate random promo code (admin only)
  generateCode: () => {
    return new Promise((resolve, reject) => {
      api()
        .post('promo-codes/generate')
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Generate code failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  // Get promo code statistics (admin only)
  getStats: () => {
    return new Promise((resolve, reject) => {
      api()
        .get('promo-codes/stats')
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Get stats failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  }
}; 